module.exports = __webpack_public_path__ + "images/emoji/trolleybus.db5d1fa08a0e1afd7ae0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/trolleybus.png
// module id = EBDn
// module chunks = 14